<template>
  <div class="product_detail_page">
    <!-- 面包屑 -->
    <div class="breadcrumb_section">
      <div class="breadcrumb_content">
        <span @click="$router.push('/')">{{ $t("Home") }}</span>
        <span class="separator">></span>
        <span @click="$router.push('/Products')">{{ $t("Products") }}</span>
        <span class="separator">></span>
        <span class="current">{{ product.name }}</span>
      </div>
    </div>

    <!-- 产品详情 -->
    <div class="product_detail_container">
      <!-- 左侧图片 -->
      <div class="product_gallery">
        <div class="main_image">
          <img v-if="product.images && product.images.length > 0" :src="product.images[currentImageIndex]"
               class="product_image" alt="product image"/>
          <img v-if="product.images && product.images.length > 0" src="../../static/img/cover_img.png"
               class="product_watermark" alt="" aria-hidden="true"/>
          <div v-else class="image_placeholder"></div>
        </div>
        <div class="thumbnail_list">
          <div
              v-for="(img, index) in product.images"
              :key="index"
              class="thumbnail"
              :class="{ active: currentImageIndex === index }"
              @click="selectImage(index)"
          >
            <img :src="img" alt="thumbnail"/>
          </div>
        </div>
      </div>

      <!-- 右侧信息 -->
      <div class="product_info">
        <pre class="product_name">{{ product.name }}</pre>
        <div class="product_desc" v-html="product.description"></div>

<!--        <ul class="features_list">-->
<!--          <li v-for="(feature, index) in product.features" :key="index">-->
<!--            <span class="sub-item-icon">● </span>{{ feature }}-->
<!--          </li>-->
<!--        </ul>-->
      </div>
    </div>

    <div class="section_wrapper" v-if="product.features && product.features.length > 0">
      <p class="section_title">{{ $t("Product Highlights") }}</p>
      <ul class="requirement_list">
        <li v-for="(req, index) in product.features" :key="index">
          <span class="sub-item-icon">● </span>{{ req }}
        </li>
      </ul>
    </div>

    <!-- Specification 规格表 -->
    <div class="section_wrapper" v-if="specificationList && specificationList.length > 0">
      <p class="section_title">{{ $t("Specification") }}</p>
      <div class="spec_table" :style="specificationList[0].length<3&&!isMiniWindows?{ maxWidth: '70%' }:{maxWidth: '100%'}">
        <table>
          <thead>
          <tr>
            <th v-for="(header, index) in specificationList[0]" :key="index">{{ header }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, rowIndex) in specificationList.slice(1)" :key="rowIndex">
            <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Ordering Information 订购信息 -->
    <div class="section_wrapper" v-if="orderingInformationList && orderingInformationList.length > 0">
      <p class="section_title">{{ $t("Ordering Information") }}</p>
      <div class="ordering_table" :style="orderingInformationList[0].length<3&&!isMiniWindows?{ maxWidth: '70%' }:{maxWidth: '100%'}">
        <table>
          <thead>
          <tr>
            <th v-for="(header, index) in orderingInformationList[0]" :key="index">{{ header }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, rowIndex) in orderingInformationList.slice(1)" :key="rowIndex">
            <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Ordering Information 第二个表格 -->
    <!--    <div class="section_wrapper" v-if="product.orderingInformation2List && product.orderingInformation2List.length > 0">-->
    <!--      <p class="section_title">{{$t("Ordering Information")}}</p>-->
    <!--      <div class="ordering_table">-->
    <!--        <table>-->
    <!--          <thead>-->
    <!--            <tr>-->
    <!--              <th v-for="(header, index) in product.orderingInformation2List[0]" :key="index">{{ header }}</th>-->
    <!--            </tr>-->
    <!--          </thead>-->
    <!--          <tbody>-->
    <!--            <tr v-for="(row, rowIndex) in product.orderingInformation2List.slice(1)" :key="rowIndex">-->
    <!--              <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>-->
    <!--            </tr>-->
    <!--          </tbody>-->
    <!--        </table>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- Requirement 要求 -->
    <div class="section_wrapper" v-if="product.requirements && product.requirements.length > 0">
      <p class="section_title">{{ $t("Requirement") }}</p>
      <ul class="requirement_list">
        <li v-for="(req, index) in product.requirements" :key="index">
          <span class="sub-item-icon">● </span>{{ req }}
        </li>
      </ul>
    </div>

    <!-- Related Products 相关产品 -->
    <div class="section_wrapper">
      <p class="section_title">{{ $t("Related Products") }}</p>
      <div class="related_grid">
        <div
            v-for="(item, index) in relatedProducts"
            :key="index"
            class="related_card"
            @click="goToDetail(item.id)"
            @mouseenter="hoveredCardIndex = index"
            @mouseleave="hoveredCardIndex = null"
        >
          <div class="related_product_img">
            <img :src="item.image" :alt="item.name"/>
          </div>
          <div class="related_info">
            <pre class="h3">{{ item.name }}</pre>
            <img
                :src="hoveredCardIndex === index ? require('../../static/img/查看产品详情箭头-选中.png') : require('../../static/img/查看产品详情箭头-未选中.png')"
                class="arrow_icon"
                alt="arrow"
            />
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import * as API from "@/api/index";

export default {
  data() {
    return {
      isMiniWindows: false,
      clientWidth: 0,
      currentImageIndex: 0,
      productId: null,
      hoveredCardIndex: null,
      specificationList: [],
      orderingInformationList: [],
      product: {
        id: 1,
        name: "LC 2.0connector",
        description: "",
        images: [],
        features: [],
        specificationEnList: [],
        specificationCnList: [],
        specificationEsList: [],
        orderingInformationEnList: [],
        orderingInformationCnList: [],
        orderingInformationEsList: [],
        requirements: [],
      },
      relatedProducts: [
        {id: 2, name: "LC0.9 Standard Type"},
        {id: 3, name: "LC0.9 Duplex"},
        {id: 4, name: "LC0.9 Bootless"},
        {id: 5, name: "LC0.9 Duplex"},
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    const id = this.$route.params.id;
    this.productId = id;
    this.getProductDetail(id);
    this.getRelatedProducts(id);

    let that = this;
    var clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    window.onresize = () => {
      return (() => {
        var clientWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  watch: {
    '$route.params.id'(id) {
      window.scrollTo(0, 0);
      this.productId = id;
      this.currentImageIndex = 0;
      this.getProductDetail(id);
      this.getRelatedProducts(id);
    },
    clientWidth(newVal) {
      this.isMiniWindows = newVal < 1200;
    },
  },
  methods: {
    selectImage(index) {
      this.currentImageIndex = index;
    },
    goToDetail(id) {
      this.$router.push(`/ProductsDetail/${id}`);
    },
    // 获取多语言字段
    getLocalizedField(item, field) {
      var result = this.$getI18nField(item, field);
      if (field==='name'){
        result=result.replace(";","\n");
      }
      return result;
    },
    // 获取产品详情
    getProductDetail(id) {
      API.getProductInfo(id)
          .then((res) => {
            if (res.code === 0 && res.product) {
              const data = res.product;
              // 解析images字段
              let images = [];
              if (data.images) {
                try {
                  images = JSON.parse(data.images);
                } catch (e) {
                  images = [];
                }
              }
              // 解析highlights字段，用';'分隔
              let features = [];
              const highlights = this.getLocalizedField(data, 'highlights');
              if (highlights) {
                features = highlights.split(';').filter(f => f.trim());
              }
              // 解析usageRequirements字段，用';'分隔
              let requirements = [];
              const requirementsCurr = this.getLocalizedField(data, 'usageRequirements');
              if (requirementsCurr) {
                requirements = requirementsCurr.split(';').filter(r => r.trim());
              }
              this.product = {
                ...this.product,
                id: data.id,
                name: this.getLocalizedField(data, 'name'),
                description: this.getLocalizedField(data, 'introduction').replaceAll(";","<br>"),
                images: images,
                features: features,
                specificationEnList: data.specificationEnList || [],
                specificationCnList: data.specificationCnList || [],
                specificationEsList: data.specificationEsList || [],
                orderingInformationEnList: data.orderingInformationEnList || [],
                orderingInformationCnList: data.orderingInformationCnList || [],
                orderingInformationEsList: data.orderingInformationEsList || [],
                requirements: requirements,
              };
              if (this.$i18n.locale === 'zh') {
                this.specificationList = this.product.specificationCnList;
                this.orderingInformationList = this.product.orderingInformationCnList;
              } else if (this.$i18n.locale === 'en') {
                this.specificationList = this.product.specificationEnList;
                this.orderingInformationList = this.product.orderingInformationEnList;
              } else {
                this.specificationList = this.product.specificationEsList;
                this.orderingInformationList = this.product.orderingInformationEsList;
              }
            }
          })
          .catch(() => {
          });
    },
    // 获取相关产品
    getRelatedProducts(productId) {
      API.getProductList({page: 1, limit: 100, excludeId: productId})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list) {
              this.relatedProducts = res.page.list.map(item => {
                // 解析images字段
                let image = '';
                if (item.images) {
                  try {
                    const images = JSON.parse(item.images);
                    image = images.length > 0 ? images[0] : '';
                  } catch (e) {
                    image = '';
                  }
                }
                return {
                  id: item.id,
                  name: this.getLocalizedField(item, 'name'),
                  image: image
                };
              });
            }
          })
          .catch(() => {
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.product_detail_page {
  margin: 0 12.5%;
  padding: 0;
  background: white;
}

.breadcrumb_section {
  background: white;
  padding: 3rem 0 0;


  .breadcrumb_content {

    margin: 0 auto;
    padding: 0;
    font-size: 1.8rem;
    color: #BDC0C5;
    text-align: left;
    font-family: regular;

    span {
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1d2087;
      }

      &.separator {
        margin: 0 1rem;
        color: #BDC0C5;
        cursor: default;
      }

      &.current {
        color: #1D2087;
        cursor: default;
      }
    }
  }
}

.product_detail_container {
  display: flex;
  justify-content: space-between;
  gap: 6rem;
  margin-top: 7.5rem;
  margin-bottom: 6rem;
}

.product_gallery {
  box-sizing: border-box;
  border: 1px solid #BDC0C5;
  padding: 0;
  width: 71rem;
  height: 56rem;
  border-radius: 1.6rem;

  .main_image {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 1.6rem;

    .product_image {
      width: 100%;
      height: 100%;
      border-radius: 1.6rem;
    }

    .product_watermark {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 521px;
      max-width: 73.4%;
      height: auto;
      transform: translate(-50%, -50%);
      pointer-events: none;
      user-select: none;
    }

    .image_placeholder {
      width: 100%;
      height: 100%;
      background: #e0e0e0;
      border-radius: 0.4rem;
    }
  }

  .thumbnail_list {
    display: flex;
    gap: 1.5rem;
    margin-top: 1rem;

    .thumbnail {
      width: 5rem;
      height: 5rem;
      cursor: pointer;
      border: 2px solid transparent;
      border-radius: 0.4rem;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      .thumb_placeholder {
        width: 100%;
        height: 100%;
        background: #e0e0e0;
      }

      &.active {
        border-color: $textBlueColor;
      }

      &:hover {
        border-color: $textBlueColor;
      }
    }
  }
}

.product_info {
  width: 59rem;

  .product_name {
    font-family: bold;
    font-size: 3.8rem;
    color: #212121;
    margin: 0 0 2rem;
    font-weight: 600;
    //line-height: 7rem;
    text-align: left;
    max-width: 100%;
    box-sizing: border-box;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .product_desc {
    font-family: regular;
    font-size: 2.2rem;
    color: #5B6370;
    line-height: 3rem;
    text-align: left;
    margin-bottom: 2.5rem;

    p {
      margin: 0;
    }
  }

  .features_list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-family: regular;
      font-size: 2.2rem;
      color: #5B6370;
      line-height: 4rem;
      //padding-left: 2rem;
      position: relative;
      text-align: left;

      .sub-item-icon {
        font-size: 2rem;
        color: #9CCF86;
        line-height: 1.5;
        display: inline-block;
        transform: scale(0.5);
      }

      //&::before {
      //  content: '';
      //  position: absolute;
      //  left: 0;
      //  top: 41%;
      //  width: 0.8rem;
      //  height: 0.8rem;
      //  background: #9CCF86;
      //  border-radius: 50%;
      //}
    }
  }
}

.section_wrapper {
  margin-top: 15rem;
  padding: 0;

  .section_title {
    margin: 0 0 5rem 0;
    text-align: left;
    font-family: bold;
    font-size: 3.8rem;
    color: #212121;
    padding-bottom: 4rem;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 8rem;
      height: 0.8rem;
      background: #1D2087;
    }
  }
}

.spec_table,
.ordering_table {
  overflow-x: auto;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;

  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #707070;
    table-layout: fixed;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;

    thead {
      tr {
        background: #1D2087;
      }

      th {
        padding: 1.5rem 2rem;
        font-size: 1.8rem;
        color: white;
        font-family: medium;
        font-weight: 500;
        line-height: 1.4;
        text-align: center;
        border-right: 1px solid #707070;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;

        &:last-child {
          border-right: none;
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #707070;

        &:last-child {
          border-bottom: none;
        }
      }

      td {
        padding: 1.5rem 2rem;
        font-size: 1.8rem;
        color: #212121;
        font-family: medium;
        font-weight: 500;
        line-height: 1.4;
        text-align: center;
        border-right: 1px solid #707070;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}

.requirement_list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-family: regular;
    font-size: 2.2rem;
    color: #5B6370;
    line-height: 4rem;
    //padding-left: 2rem;
    position: relative;
    text-align: left;

    .sub-item-icon {
      font-size: 2rem;
      color: #9CCF86;
      line-height: 1.5;
      display: inline-block;
      transform: scale(0.5);
    }

    //&::before {
    //  content: '';
    //  position: absolute;
    //  left: 0;
    //  top: 41%;
    //  width: 0.8rem;
    //  height: 0.8rem;
    //  background: #9CCF86;
    //  border-radius: 50%;
    //}
  }
}

.related_grid {
  display: flex;
  gap: 3rem;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  padding: 2px 2px 1rem;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 26rem;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #1D2087;
  }

  .related_card {
    flex: 0 0 calc((100% - 9rem) / 4);
    //background: white;
    //border: 1px solid #e0e0e0;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    box-sizing: border-box;

    .related_product_img {
      height: 27rem;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 2rem;
      //background: #F5F5F5;
      border: 1px solid #BDC0C5;
      border-radius: 1rem;
      transition: all 0.3s;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        box-sizing: border-box;
      }
    }

    .related_image_placeholder {
      width: 100%;
      height: 18rem;
      background: #e0e0e0;
    }

    .related_info {
      display: flex;
      margin-top: 1.8rem;
      justify-content: space-between;
      align-items: center;

      .h3 {
        font-family: regular;
        font-size: 2rem;
        color: #5B6370;
        text-align: left;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .arrow_icon {
        width: 1.8rem;
        height: auto;
        margin-left:0.6rem;
      }
    }

    .related_name {
      padding: 1.5rem;
      text-align: center;
      font-size: 1.4rem;
      color: $color2C;
      margin: 0;
      min-height: 5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      //box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      //transform: translateY(-0.3rem);
      .related_product_img {
        box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
        border: 1px solid #1D2087;
      }

      .related_name {
        color: $textBlueColor;
      }
    }
  }
}

.contacts_section {
  background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);
  padding: 5rem 4rem;
  margin: 0 -2rem -2rem;
  text-align: center;

  .contacts_title {
    font-size: 3.2rem;
    color: white;
    margin: 0 0 2rem;
    font-weight: 600;
  }

  .contacts_content {
    .contacts_subtitle {
      font-size: 1.8rem;
      color: white;
      margin: 0 0 3rem;
    }

    .contacts_info {
      display: flex;
      justify-content: center;
      gap: 6rem;

      .contact_item {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-size: 1.6rem;
        color: white;

        i {
          font-size: 2rem;
        }
      }
    }
  }
}

@media (min-width: 2000px) {
  .product_info {
    max-width: 55%;
    width: auto;
  }
}

@media (max-width: 1200px) {
  .product_detail_container {
    flex-direction: column;
    gap: 3rem;
  }

  .product_gallery {
    flex: 0 0 100%;

    .main_image {
      height: 30rem;
    }
  }

  .product_info {
    .product_name {
      font-size: 2.6rem;
    }
  }

  .related_grid {
    gap: 2rem;

    .related_card {
      flex: 0 0 28rem;
      min-width: 28rem;
    }
  }

  .contacts_section {
    .contacts_info {
      flex-direction: column;
      gap: 2rem;
    }
  }
}

@media (max-width: 768px) {
  .product_detail_page {
    margin: 0 2rem;
    padding: 0;
  }

  .breadcrumb_section {
    padding: 2rem 0 0;

    .breadcrumb_content {
      font-size: 1.4rem;
      padding: 0;
    }
  }

  .product_detail_container {
    margin-top: 4rem;
    margin-bottom: 4rem;
    display: flex;
    gap: 2rem;
  }

  .product_gallery {
    width: 100%;
    padding: 0;

    .main_image {
      height: 30rem;
    }

    .thumbnail_list {
      display: flex;
      gap: 1rem;
      padding: 1rem;

      .thumbnail {
        width: 4rem;
        height: 4rem;
      }
    }
  }

  .product_info {
    width: 100%;

    .product_name {
      font-size: 2.5rem;
      line-height: 3rem;
      margin: 0 0 1.5rem;
    }

    .product_desc {
      font-size: 1.6rem;
      line-height: 2.4rem;
      margin-bottom: 2rem;
    }

    .features_list li {
      font-size: 1.6rem;
      line-height: 1.6;
      padding-left: 1.5rem;
    }
  }

  .section_wrapper {
    margin-top: 8rem;
    padding: 0;

    .section_title {
      font-size: 2.5rem;
      margin: 0 0 3rem 0;
      padding-bottom: 2rem;
    }

    .section_title::after {
      width: 5rem;
    }
  }

  .spec_table,
  .ordering_table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;

    table {
      min-width: 100%;
      table-layout: auto;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;

      thead th {
        padding: 1rem 1.5rem;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 1.4;
        white-space: nowrap;
      }

      tbody td {
        padding: 1rem 1.5rem;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 1.4;
        white-space: nowrap;
      }
    }
  }

  .requirement_list li {
    font-size: 1.6rem;
    line-height: 3rem;
    padding-left: 1.5rem;
  }

  .related_grid {
    gap: 2rem;
    margin-bottom: 15rem;
    padding-bottom: 1rem;

    &::-webkit-scrollbar {
      height: 0.6rem;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
      background: #1D2087;
      border-radius: 1rem;
    }

    .related_card {
      flex: 0 0 28rem;
      min-width: 28rem;
      background: transparent;

      .related_product_img {
        height: 16rem;
        padding: 1.5rem;
        background: transparent;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .related_info {
        .h3 {
          font-size: 1.4rem;
        }

        img {
          width: 2rem !important;
          height: 2rem !important;
        }
      }
    }
  }

  .contacts_section {
    padding: 3rem 1rem;

    .contacts_title {
      font-size: 2.4rem;
    }

    .contacts_content .contacts_subtitle {
      font-size: 1.5rem;
    }
  }
}
</style>
